export default "__VITE_ASSET__ab88bc33__"